import React from 'react';
import T from './EditableText';

/**
 * „Auf einen Blick": sechs Zeilen Kernfakten oben auf einer Leistungsseite.
 *
 * Für Menschen, die nur die Kernfrage haben — und für Suchmaschinen und
 * KI-Assistenten, die genau solche Kurzfassungen zitieren, wenn jemand nach
 * „was kostet 24 stunden pflege" fragt. Als Definitionsliste, damit Begriff
 * und Wert auch ohne Layout zusammengehören.
 *
 * Die Texte kommen aus `<prefix>.titel` und `<prefix>.<n>.label` /
 * `<prefix>.<n>.wert` für n = 1…6 und sind damit im Bearbeiten-Modus änderbar.
 */
const ROWS = [1, 2, 3, 4, 5, 6];

const FactBox: React.FC<{ prefix: string }> = ({ prefix }) => (
  <aside className="facts" aria-labelledby={`${prefix}-titel`}>
    <h2 id={`${prefix}-titel`}>
      <T k={`${prefix}.titel`} />
    </h2>
    <dl>
      {ROWS.map((n) => (
        <div className="facts__row" key={n}>
          <dt>
            <T k={`${prefix}.${n}.label`} />
          </dt>
          <dd>
            <T k={`${prefix}.${n}.wert`} />
          </dd>
        </div>
      ))}
    </dl>
  </aside>
);

export default FactBox;
